import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { I18n } from 'react-redux-i18n-lite';
import { filterStudentsByQuery } from '../MultipleSelectionPanel';

/**
 * Mobile multiple selection of the Assign sheet (Vista Mobile 3c): search field and one row per
 * student with name and email (ellipsis) and a checkbox; the whole row toggles the student.
 */
const AssignStudentsList = ({ students, selectedUsers, selectStudent }) => {
  const [query, setQuery] = useState('');
  const visibleStudents = filterStudentsByQuery(students, query);

  return (
    <div className="assign-students">
      <div className="assign-students-search">
        <label className="assign-students-search-field">
          <i className="custom-icons-magnifying-glass-browser" aria-hidden="true" />
          <input
            type="search"
            value={query}
            placeholder={I18n.t('tasks.users.searchPlaceholder')}
            onChange={event => setQuery(event.target.value)}
          />
        </label>
      </div>
      <ul className="assign-students-list">
        {visibleStudents.map(student => {
          const isSelected = (selectedUsers || []).some(user => user._id === student._id);
          return (
            <li key={student._id}>
              <button
                type="button"
                role="checkbox"
                aria-checked={isSelected}
                className={`assign-student ${student.enabled === 1 ? '' : 'disabled'}`}
                onClick={() => selectStudent(student)}
              >
                <img className="assign-student-avatar" src={student.picture} alt="" />
                <span className="assign-student-text">
                  <span className="assign-student-name">{`${student.surname}, ${student.name}`}</span>
                  {student.email && <span className="assign-student-email">{student.email}</span>}
                </span>
                <span className={`assign-student-checkbox ${isSelected ? 'checked' : ''}`} aria-hidden="true">
                  {isSelected && <i className="custom-icons-check-icon" />}
                </span>
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

AssignStudentsList.propTypes = {
  students: PropTypes.array,
  selectedUsers: PropTypes.array,
  selectStudent: PropTypes.func.isRequired
};

export default AssignStudentsList;
